import { ValveClosed, ValveError, ValveOpen, ValveUnknown } from '../../../../../components/ui-icons/valve-icons'

const ValvePositionItem = ({ value }: { value: string }) => {
  const { ariaLabel, IconComponent } = {
    open: { ariaLabel: 'Open', IconComponent: ValveOpen },
    closed: { ariaLabel: 'Closed', IconComponent: ValveClosed },
    error: { ariaLabel: 'Error', IconComponent: ValveError },
    unknown: { ariaLabel: 'Unknown', IconComponent: ValveUnknown },
  }[value] ?? { ariaLabel: 'Unknown', IconComponent: ValveUnknown }

  return <IconComponent ariaLabel={ariaLabel} />
}

export default ValvePositionItem
